import { useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';

interface Props {
  sets: number;
  reps: number;
  suggestedLoad?: number | null;
  onSave: (result: { setsDone: number; repsDone: number; loadUsed: number | null }) => void;
}

export function WorkoutLogForm({ sets, reps, suggestedLoad, onSave }: Props) {
  const [load, setLoad] = useState(suggestedLoad ? String(suggestedLoad) : '');

  function handleSave() {
    onSave({ setsDone: sets, repsDone: reps, loadUsed: load ? parseFloat(load) : null });
  }

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <View style={styles.field}>
          <Text style={styles.label}>Séries</Text>
          <View style={styles.staticBox}>
            <Text style={styles.staticValue}>{sets}</Text>
          </View>
        </View>
        <View style={styles.field}>
          <Text style={styles.label}>Reps</Text>
          <View style={styles.staticBox}>
            <Text style={styles.staticValue}>{reps}</Text>
          </View>
        </View>
        <View style={styles.field}>
          <Text style={styles.label}>Carga (kg)</Text>
          <TextInput
            style={styles.input}
            value={load}
            onChangeText={setLoad}
            keyboardType="decimal-pad"
            placeholder="—"
          />
        </View>
      </View>
      <TouchableOpacity style={styles.button} onPress={handleSave}>
        <Text style={styles.buttonText}>Salvar</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { backgroundColor: '#F5F5F5', padding: 16, borderRadius: 10 },
  row: { flexDirection: 'row', gap: 12 },
  field: { flex: 1 },
  label: { fontSize: 12, color: '#888888', marginBottom: 4 },
  staticBox: { borderWidth: 1, borderColor: '#eee', borderRadius: 6, padding: 10, backgroundColor: '#f0f0f0', alignItems: 'center' },
  staticValue: { fontSize: 15, fontWeight: '600', color: '#444' },
  input: { borderWidth: 1, borderColor: '#C8102E55', borderRadius: 6, padding: 10, textAlign: 'center', backgroundColor: '#fff', fontSize: 15, color: '#1A1A1A' },
  button: { backgroundColor: '#2E7D32', padding: 12, borderRadius: 8, alignItems: 'center', marginTop: 12 },
  buttonText: { color: '#fff', fontWeight: 'bold' },
});
